export enum PayByBankAccountType {
  DYNAMIC_DEPOSIT_ACCOUNT_TYPE_SAVING = "DYNAMIC_DEPOSIT_ACCOUNT_TYPE_SAVING",
  DYNAMIC_DEPOSIT_ACCOUNT_TYPE_CHECKING = "DYNAMIC_DEPOSIT_ACCOUNT_TYPE_CHECKING",
  DYNAMIC_DEPOSIT_ACCOUNT_TYPE_CORPORATE_CHECKING = "DYNAMIC_DEPOSIT_ACCOUNT_TYPE_CORPORATE_CHECKING",
  DYNAMIC_DEPOSIT_ACCOUNT_TYPE_UNSPECIFIED = "DYNAMIC_DEPOSIT_ACCOUNT_TYPE_UNSPECIFIED",
}
